export type PrintType = "print:1" | "print:2" | "print:3";
export type OrderTableType = "Table Type:1" | "Table Type:2";
export type BusinessOperationType = "Day" | "Shift";
export type BillResetPeriod = "noreset" | "day" | "week" | "month" | "year";
export type DateFormat = "DD/MM/YYYY" | "MM/DD/YYYY" | "YYYY/MM/DD" | "DD-MM-YYYY" | "MM-DD-YYYY" | "YYYY-MM-DD";
export type TimeFormat = "12h" | "24h";
export interface PrintSettings {
  printType: PrintType;
  orderTableType: OrderTableType;
  isDualCopy: boolean;
  printProductLimit: string;
}

export interface TableBillingSettings {
  tableRows: number;
  billNoEnabled: boolean;
  billNo: BillResetPeriod;
  orderIdEnabled: boolean;
  clientIdEnabled: boolean;
  customBusinessName?: string;
  parcelFeeEnabled: boolean;
  tipsEnabled: boolean;
}

export interface posConfigSettings {
  deliveryFeeEnabled: boolean;
  cardEnabled: boolean;
  orderEditingEnabled: boolean;
  creditControlEnabled: boolean;
}

export interface TermsConditionsSettings {
  addTC: boolean;
  tcEnglish: string;
  tcArabic: string;
}

export interface QRSettings {
  contactQR: {
    file: File | null;
    preview: string;
  };
  locationQR: {
    file: File | null;
    preview: string;
  };
}

export interface ReportsSettings {
  pdfProductLimit: string;
  showOutstanding: boolean;
}

export interface FoodTypesSettings {
  foodTypes: string[];
}

export interface BusinessOperationSettings {
  businessOperationEnable: boolean;
  businessOperationType: BusinessOperationType;
  shiftTypes: string[];
}

export interface HomepageSettings {
  isDefaultTabsEnabled: boolean;
  isProductsNotesEnabled: boolean;
}

export interface PrinterSettings {
  appPrinterEnabled: boolean;
  selectedPrinters: string[];
}

export interface ConfigurationState
  extends
    PrintSettings,
    TableBillingSettings,
    posConfigSettings,
    TermsConditionsSettings,
    QRSettings,
    ReportsSettings,
    FoodTypesSettings,
    BusinessOperationSettings,
    HomepageSettings,
    PrinterSettings {
  businessName: string;
  productEditEnabled: boolean;
  dateFormat?: DateFormat;
  timeFormat?: TimeFormat;
}

export const DEFAULT_FOOD_TYPES = ["Veg", "Non-Veg"];
export const DEFAULT_SHIFT_MANAGE = ["Morning Shift", "Evening Shift"];
export const MAX_TYPES = 5;

export const dropDownValue = [
  { _id: "10", CategoryName: "10" },
  { _id: "25", CategoryName: "25" },
  { _id: "50", CategoryName: "50" },
  { _id: "100", CategoryName: "100" },
  { _id: "250", CategoryName: "250" },
  { _id: "500", CategoryName: "500" },
];

export const billNoDropDownValue = [
  { _id: "noreset", CategoryName: "No reset" },
  { _id: "day", CategoryName: "Day" },
  { _id: "week", CategoryName: "Week" },
  { _id: "month", CategoryName: "Month" },
  { _id: "year", CategoryName: "Year" },
];

export const dateFormatOptions = [
  { _id: "DD/MM/YYYY", CategoryName: "DD/MM/YYYY" },
  { _id: "MM/DD/YYYY", CategoryName: "MM/DD/YYYY" },
  { _id: "YYYY/MM/DD", CategoryName: "YYYY/MM/DD" },
  { _id: "DD-MM-YYYY", CategoryName: "DD-MM-YYYY" },
  { _id: "MM-DD-YYYY", CategoryName: "MM-DD-YYYY" },
  { _id: "YYYY-MM-DD", CategoryName: "YYYY-MM-DD" },
];

export const timeFormatOptions = [
  { _id: "12h", CategoryName: "12 Hours (12:00:00 PM)" },
  { _id: "24h", CategoryName: "24 Hours (13:00:00)" },
];
